export default __webpack_public_path__ + "static/media/(103).46da0d57.jpg";